const EXIT_CTA_LABEL = {
  BACK_TO_LISTING: 'Back to listing',
  EXIT: 'Exit',
  SAVE_AND_EXIT: 'Save & exit',
};

const WIZARD_TITLE_ID = 'page-wizard-title';

export { EXIT_CTA_LABEL, WIZARD_TITLE_ID };
